// Final steps section form field enum
export enum FinalStepsFormField {
  FINAL_STEPS_CURRENT_CERT_PERIOD = 'finalStepsCurrentCertPeriod',
  FINAL_STEPS_DISCHARGE_COMMUNICATION = 'finalStepsDischargeCommunication',
  FINAL_STEPS_RESOURCES_PROVIDED = 'finalStepsResourcesProvided',
  FINAL_STEPS_CAREGIVER_RESPONSE = 'finalStepsCaregiverResponse',
  FINAL_STEPS_DATE_PHYSICIAN_NOTIFIED = 'finalStepsDatePhysicianNotified',
  FINAL_STEPS_DISCHARGE_NARRATIVE = 'finalStepsDischargeNarrative',
  FINAL_STEPS_INTERNAL_NOTES = 'finalStepsInternalNotes'
}
